<template>
  <svg width="13" height="13" viewBox="0 0 13 13" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clipteam)">
      <path
          d="M10.291 6.5C11.1885 6.5 11.916 5.77246 11.916 4.875C11.916 3.97754 11.1885 3.25 10.291 3.25C9.39355 3.25 8.66602 3.97754 8.66602 4.875C8.66602 5.77246 9.39355 6.5 10.291 6.5Z"
          fill="currentColor"/>
      <path
          d="M2.70898 6.5C3.60645 6.5 4.33398 5.77246 4.33398 4.875C4.33398 3.97754 3.60645 3.25 2.70898 3.25C1.81152 3.25 1.08398 3.97754 1.08398 4.875C1.08398 5.77246 1.81152 6.5 2.70898 6.5Z"
          fill="currentColor"/>
      <path
          d="M6.50065 5.95833C7.69726 5.95833 8.66731 4.98828 8.66731 3.79167C8.66731 2.59505 7.69726 1.625 6.50065 1.625C5.30403 1.625 4.33398 2.59505 4.33398 3.79167C4.33398 4.98828 5.30403 5.95833 6.50065 5.95833Z"
          fill="currentColor"/>
      <path
          d="M11.9161 7.04175H10C10.1911 7.37079 10.2915 7.74459 10.2911 8.12508V11.9167H12.4578C12.6015 11.9167 12.7392 11.8597 12.8408 11.7581C12.9424 11.6565 12.9995 11.5187 12.9995 11.3751V8.12508C12.9995 7.83776 12.8853 7.56221 12.6822 7.35905C12.479 7.15588 12.2035 7.04175 11.9161 7.04175Z"
          fill="currentColor"/>
      <path
          d="M2.99982 7.04175H1.08333C0.796016 7.04175 0.520465 7.15588 0.317301 7.35905C0.114137 7.56221 0 7.83776 0 8.12508L0 11.3751C0 11.5187 0.0570683 11.6565 0.158651 11.7581C0.260233 11.8597 0.398008 11.9167 0.541667 11.9167H2.70833V8.12508C2.70806 7.74456 2.80863 7.37076 2.99982 7.04175Z"
          fill="currentColor"/>
      <path
          d="M8.125 5.95825H7.58333L6.5 9.20824L5.41667 5.95825H4.875C4.44402 5.95825 4.0307 6.12946 3.72595 6.4342C3.4212 6.73895 3.25 7.15227 3.25 7.58325V12.4582C3.25 12.6019 3.30707 12.7397 3.40865 12.8412C3.51023 12.9428 3.64801 12.9999 3.79167 12.9999H9.20833C9.35199 12.9999 9.48977 12.9428 9.59135 12.8412C9.69293 12.7397 9.75 12.6019 9.75 12.4582V7.58325C9.75 7.15227 9.5788 6.73895 9.27405 6.4342C8.9693 6.12946 8.55598 5.95825 8.125 5.95825Z"
          fill="currentColor"/>
    </g>
    <defs>
      <clipPath id="clipteam">
        <rect width="13" height="13" fill="white"/>
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  name: "IconTeam"
}
</script>

<style scoped>

</style>